// Se ejecuta dentro del gesto del usuario; conserva el control nativo como fallback.
export function abrirSelectorFechaHora(event){
 const input=event.currentTarget;
 if(typeof input.showPicker==='function'){
  try{input.showPicker();return;}catch{}
 }
 input.focus();
}
